<ng-container *ngIf="loading">
    <mapfre-loading></mapfre-loading>
  </ng-container>
<mapfre-modal 
    *ngIf="policy?.days_left_to_expire > 30" 
    [modalOptions]="unEnrollModalOptions" 
    [hideModal]="hideModal" 
    (hideModalOutput)="resetHideModal()"
    (openModal)="onOpenModal()"
>
    <div class="modal-body eft-confirm-container-modal">
         <div class="text-center">
            <div class="modal-icon-box-center">
                <img src={{modalIcon}} alt="unenroll icon"/>
            </div>
            <ng-container *ngIf="action === 'unenroll'; else editLayout">
                <div class="autopay-title">
                    Looking to unenroll your {{ policy?.displayType?.label | lowercase }} 
                    <span class="web-line-break">policy {{ policy?.policynumber.policyNumber }} from autopay?</span>
                </div>
                <div class="autopay-modal-sub-title mt-3 mb-3" [ngClass]="{ 'mt-4 mb-4': isAcmic }">
                    Unenrolling from autopay changes your pay plan. 
                    <p><strong>
                        This increases your monthly payments and 
                        <span [ngClass]="{ 'web-line-break': !isAcmic }">installment fees.</span>
                    </strong></p>                
                </div>

                <app-imp-notice [theme]="'red'" [policy]="policy"></app-imp-notice>
            </ng-container>
            <ng-template #editLayout>
                <div class="autopay-title web-width-380">
                    To edit your credit/debit card you need to uneroll and enroll again with the new card details
                </div>
            </ng-template>

            <ng-container *ngIf="policy?.autoPayDetails?.cardType && isAcmic; else others">
                <div class="acmic-cc-dc-sec">
                    <div class="modal-info col-656565">
                        To discuss your options, contact our 
                        <span class="web-break">Customer Service department</span>
                    </div>
                    <div>
                        <a href="tel:18442954500" class="claim-details-link">
                            1-844-295-4500
                        </a>
                    </div>
                </div>
                
                <hr class="devided-line mt-4 mb-4"/>
                <div class="mx-auto align-text-right">
                    <div>
                        <mapfre-button 
                            additionalClasses="ghost secondary large-btn cc-dc-button" 
                            (click)="hideModalAction($event)"
                        >
                            {{ 'CANCEL' | translate }}
                        </mapfre-button>
                    </div>
                </div>
            </ng-container>
            <ng-template #others>
                <div class="modal-info mt-3">
                    {{ 'Do you still want to unenroll?' | translate }}
                </div>
                <hr class="devided-line mt-4 mb-4"/>
                <div class="btn-row-column unenroll-btn-dist">
                    <div>
                        <mapfre-button additionalClasses="ghost secondary large" (click)="onKeepEnroll(); hideModalAction($event)">
                            {{ 'Keep me enrolled' | translate }}
                        </mapfre-button>
                    </div>
                    <div>
                        <mapfre-button 
                            additionalClasses="basic primary large" 
                            (click)="onUnenroll(); hideModalAction($event);"
                        >
                            {{ (action === 'unenroll' ? 'Unenroll' : 'Unenroll to edit card') | translate }}
                        </mapfre-button>
                    </div>                
                </div>
            </ng-template>
        </div>                    
    </div>
</mapfre-modal>